import React, { useEffect, useState } from 'react'
import { DESKTOP_MIN, LARGE_DESKTOP_MIN, PHONE_MAX, TABLET_MIN, TABLET_MAX } from './components/styledUtils'

export type WindowWidth = {
  isDesktopOrLarger: boolean
  isLargeDesktopOrSmaller: boolean
  isDesktopOrSmaller: boolean
  isTabletOrSmaller: boolean
  isPhoneOrSmaller: boolean
  bootstrapContainerInnerWidth: number
}

export const WindowWidthContext = React.createContext<WindowWidth>({
  isDesktopOrLarger: false,
  isLargeDesktopOrSmaller: false,
  isDesktopOrSmaller: false,
  isTabletOrSmaller: false,
  isPhoneOrSmaller: false,
  bootstrapContainerInnerWidth: 0
})

export function computeWindowWidth(width: number): WindowWidth {
  return {
    isDesktopOrLarger: width >= DESKTOP_MIN,
    isLargeDesktopOrSmaller: width < LARGE_DESKTOP_MIN,
    isDesktopOrSmaller: width < DESKTOP_MIN,
    isTabletOrSmaller: width <= TABLET_MAX,
    isPhoneOrSmaller: width <= PHONE_MAX,
    bootstrapContainerInnerWidth: getBootstrapContainerInnerWidth(width)
  }
}

export const WindowWidthContextProvider = ({ children }: React.PropsWithChildren) => {
  const [windowWidth, setWindowWidth] = useState<WindowWidth>(computeWindowWidth(window.innerWidth))

  const onResize = () => {
    setWindowWidth(computeWindowWidth(window.innerWidth))
  }

  useEffect(() => {
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return <WindowWidthContext.Provider value={windowWidth}>{children}</WindowWidthContext.Provider>
}

const horizontalContainerPadding = 30
function getBootstrapContainerInnerWidth(windowWidth: number) {
  if (windowWidth < TABLET_MIN) {
    return windowWidth - horizontalContainerPadding
  } else if (windowWidth < DESKTOP_MIN) {
    return 750 - horizontalContainerPadding
  } else if (windowWidth < LARGE_DESKTOP_MIN) {
    return 970 - horizontalContainerPadding
  } else {
    return 1170 - horizontalContainerPadding
  }
}
